// connect-api #228 collapses the dual `id`/`rj_id` (and `site_id`/`rj_site_id`)
// wire fields into a single hashid string, dropping the legacy `rj_*` field.
// Downstream code keys off the `rj_*` name, so before validation we backfill it
// from the collapsed field when the legacy one is absent. Pre-#228 payloads
// (which still carry the `rj_*` field) pass through untouched.
function makeBackfill(target: string, source: string) {
  return (raw: unknown): unknown => {
    if (raw && typeof raw === "object" && !Array.isArray(raw)) {
      const obj = raw as Record<string, unknown>;
      if (
        (obj[target] == null || obj[target] === "") &&
        typeof obj[source] === "string" &&
        obj[source] !== ""
      ) {
        return { ...obj, [target]: obj[source] };
      }
    }
    return raw;
  };
}

export const backfillRjIdFromId = makeBackfill("rj_id", "id");
export const backfillRjSiteIdFromSiteId = makeBackfill("rj_site_id", "site_id");
